import { useState } from "react";
import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import Drawer from "components/ui/drawer/Drawer";
import { TrackingProvider } from "lib/tracking";
import { Flex, Text } from "../../../../styles/utility-components";
import { ListEntities, SaveToLists } from "./SaveToLists";

type Props = {
  entityType: ListEntities;
  entityIds: string[];
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
};

/**
 * Slideout drawer which opens and allows us to save an entity to a list
 */
export default function SaveListDrawer({ isOpen, onOpenChange, entityType, entityIds }: Props) {
  const [isCreateFormOpen, setIsCreateFormOpen] = useState(false);

  return (
    <Drawer open={isOpen} onOpenChange={onOpenChange} width={486} padding={24}>
      <TrackingProvider data={{ "Data type": entityType.toUpperCase() }}>
        <DrawerContent aria-label={`Save this ${entityType} to a list`}>
          <Flex justifyContent="space-between" alignItems="flex-start">
            {isCreateFormOpen ? (
              <Button
                as="button"
                buttonType="secondary"
                icon="arrowNarrowLeft"
                onClick={() => setIsCreateFormOpen(false)}
              />
            ) : (
              <Text h3>Save to a list</Text>
            )}
            <Button
              as="button"
              buttonType="secondary"
              icon="xClose"
              onClick={() => onOpenChange(false)}
            />
          </Flex>
          <Flex column height="100%">
            <SaveToLists
              entityType={entityType}
              entityIds={entityIds}
              isCreateFormOpen={isCreateFormOpen}
              onToggleCreateForm={setIsCreateFormOpen}
            />
          </Flex>
        </DrawerContent>
      </TrackingProvider>
    </Drawer>
  );
}

const DrawerContent = styled(Flex)({
  flexDirection: "column",
  height: "100%",
  gap: 24,
  maxWidth: "440px",
});
